

import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  StyleSheet,
  Dimensions,
} from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { Modal } from '@material-ui/core';
import FeatureTable from './fature';
import { useDispatch, useSelector } from 'react-redux';
import { tenantActions } from '../../../redux/tenant.actions';
import { showErrorToast } from '../../helpers';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from '../commanBuyCertificate/checkoutForm';
import { loadStripe } from '@stripe/stripe-js/pure';
const { width } = Dimensions.get('window');
import success from "./../../../../../assets/images/success.svg";
import failed from "./../../../../../assets/images/failed.png";
import { AntDesign } from '@expo/vector-icons';
import ajax from '../../../../../helpers/ajaxHelper';
import Urls from '../../../../../services/Urls';
import { saveUserProfile } from '../../../../../redux/action/authActions';

const STRIPEKEY = 'pk_test_51MlCEgFCJVtBrQ2WeGxu4iXpX0LA2dekCg14KkHjdxV9IKctdQuxgQWw9xpS8dDGxlfNlcD4G653CQMgAuzv70Lg00IG4xLCCA';

const VerifyModal = ({ visible, onClose }) => {
  const [clientSecret, setClientSecret] = React.useState('');
  const stripePromise = loadStripe(STRIPEKEY);
  const [page, setPage] = React.useState(0);


  const openflowBuyPackageResponseData = useSelector((state) => state.tenant?.packages);
  const [selectedPack, setSelectedPack] = useState(null);

  // Fetch the landlord_verification package from the backend on mount
  useEffect(() => {
    ajax.get('v1.0/hubflow/packages?type=landlord_verification')
      .then(({ data }) => {
        if (data?.payload?.length > 0) {
          setSelectedPack(data.payload[0]);
        }
      })
      .catch(console.error);
  }, []);

  console.log("openflowBuyPackageResponseData", openflowBuyPackageResponseData)
  const dispatch = useDispatch()
  const buyPackage = () => {
    if (selectedPack?.hubita_package_id) {
      let data = {
        ...selectedPack,
        amount: selectedPack.price,
        hubita_package_id: selectedPack.hubita_package_id
      }
      dispatch(tenantActions.buyFlowPackage(data, (daraaa) => {
        console.log("daraaa", daraaa)

        setClientSecret(daraaa?.data?.clientSecret)
        setPage(1)
      }));
    } else {
      showErrorToast("Please select package!")
    }

  };
  const renderSuccess = () => {
    return (
      <View style={styles.modalContainer}>
        <img src={success} style={{ height: 100, marginTop: 20 }} />

        <Text
          marginBottom={30}
          marginTop={40}
          style={{ alignSelf: "center", textAlign: "center", marginBottom: 30, marginTop: 40, fontSize: 26, fontWeight: 700, color: "black" }}
        >
          Payment Successfull!
        </Text>

        <View style={{ backgroundColor: "#1B8A8C", width: 100, height: 2, alignSelf: "center", marginBottom: 20 }} />
        <TouchableOpacity
          onPress={() => {
            setPage(0)

            onClose(true)
          }}
          style={{
            marginTop: 10,
            paddingHorizontal: 20,
            backgroundColor: "white", borderColor: "#536DFE",
            borderWidth: 1,
            boxShadow: "0px 2px 11px 1px rgba(0,0,0,0.09)",
            alignSelf: "center",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 10,
            paddingVertical: 10,
            flexDirection: "row"
          }}
        >
          <Text
            style={{ alignSelf: "center", fontSize: 20, fontWeight: 700, color: "#536DFE" }}
          >
            Continue
          </Text>
          <AntDesign
            style={{ marginLeft: 20 }}
            name="arrowright" size={24} color="#536DFE" />
        </TouchableOpacity>
        <Text
          style={{ marginTop: 30, alignSelf: "center", textAlign: "center", fontSize: 20, fontWeight: 400, color: "black" }}
        >
          Thank you for your payment. Please click continue to start your order.
        </Text>
        <Text
          style={{ marginTop: 10, alignSelf: "center", textAlign: "center", fontSize: 20, fontWeight: 400, color: "black" }}>
          You will receive confirmation of this payment via email.
        </Text>
      </View>
    )
  }
  const renderFail = () => {
    return (
      <View style={styles.modalContainer}>
        <img src={failed} style={{ height: 30, width: 30, alignSelf: "center", marginTop: 20 }} />

        <Text
          marginBottom={30}
          marginTop={40}
          style={{ alignSelf: "center", marginBottom: 30, marginTop: 40, fontSize: 26, fontWeight: 700, color: "black" }}
        >
          Payment Failed!
        </Text>

        <View style={{ backgroundColor: "#1B8A8C", width: 100, height: 2, alignSelf: "center", marginBottom: 20 }} />
        <TouchableOpacity
          onPress={() => {
            setPage(0)
            onClose()
          }}
          style={{
            marginTop: 10,
            paddingHorizontal: 20,
            backgroundColor: "white", borderColor: "#536DFE",
            borderWidth: 1,
            boxShadow: "0px 2px 11px 1px rgba(0,0,0,0.09)",
            alignSelf: "center",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 10,
            paddingVertical: 10,
            flexDirection: "row"
          }}
        >
          <Text
            style={{ alignSelf: "center", fontSize: 20, fontWeight: 700, color: "#536DFE" }}
          >
            Back
          </Text>
          <AntDesign
            style={{ marginLeft: 20 }}
            name="arrowright" size={24} color="#536DFE" />
        </TouchableOpacity>

      </View>
    )
  }
  return (
    <Modal
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
        flex: 1
      }}
      open={visible ? visible : false} onBackdropPress={onClose} backdropOpacity={0.3}>
      <>

        {page == 1 ? (
          <View style={styles.checkoutModalCard}>
            {/* Header */}
            <View style={styles.checkoutHeaderRow}>
              <View style={{ flex: 1 }}>
                <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                  <Text style={styles.checkoutTitleText}>Checkout</Text>
                  <View style={styles.secureBadge}>
                    <AntDesign name="Safety" size={13} color="#10B981" />
                    <Text style={styles.secureBadgeText}>Secure</Text>
                  </View>
                </View>
                <Text style={styles.checkoutSubtitleText}>Landlord ID & KYC Verification</Text>
              </View>
              <TouchableOpacity
                onPress={() => {
                  setPage(0);
                  onClose();
                }}
                style={styles.closeBtnCircle}
                activeOpacity={0.7}
              >
                <AntDesign name="close" size={15} color="#64748B" />
              </TouchableOpacity>
            </View>

            {/* Scrollable Form Content without native scrollbars */}
            <ScrollView
              showsVerticalScrollIndicator={false}
              style={styles.checkoutScrollArea}
              contentContainerStyle={styles.checkoutScrollContent}
            >
              {/* Order Summary Card */}
              <View style={styles.summaryCard}>
                <View style={styles.summaryTopRow}>
                  <View style={{ flex: 1, marginRight: 10 }}>
                    <Text style={styles.summaryItemTitle}>{selectedPack?.name || 'Landlord Verification'}</Text>
                    <Text style={styles.summaryItemSub}>Instant identity verification & compliance</Text>
                  </View>
                  <View style={styles.summaryTag}>
                    <Text style={styles.summaryTagText}>Verified</Text>
                  </View>
                </View>

                <View style={styles.summaryDivider} />

                <View style={styles.summaryDetailRow}>
                  <Text style={styles.summaryDetailLabel}>Subtotal</Text>
                  <Text style={styles.summaryDetailValue}>£{Number(selectedPack?.price || 0).toFixed(2)}</Text>
                </View>

                <View style={styles.summaryDetailRow}>
                  <Text style={styles.summaryDetailLabel}>VAT (20%)</Text>
                  <Text style={styles.summaryDetailValue}>£{Number(selectedPack?.vat || 0).toFixed(2)}</Text>
                </View>

                <View style={[styles.summaryDivider, { marginVertical: 10 }]} />

                <View style={styles.summaryTotalRow}>
                  <Text style={styles.summaryTotalLabel}>Total Amount</Text>
                  <Text style={styles.summaryTotalValue}>
                    £{(Number(selectedPack?.vat || 0) + Number(selectedPack?.price || 0)).toFixed(2)}
                  </Text>
                </View>
              </View>

              {/* Stripe Payment Form */}
              <Elements
                stripe={stripePromise}
                options={{
                  clientSecret: clientSecret,
                  appearance: {
                    theme: 'stripe',
                    variables: {
                      colorPrimary: '#6C2BD9',
                      borderRadius: '8px',
                      fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                    },
                  },
                }}
              >
                <CheckoutForm
                  totalAmount={(Number(selectedPack?.vat || 0) + Number(selectedPack?.price || 0)).toFixed(2)}
                  onSuccessToken={(success) => {
                    if (success) {
                      ajax.get(Urls.PROFILE)
                        .then(({ data }) => {
                          if (data?.data?.userDetails) {
                            dispatch(saveUserProfile(data?.data?.userDetails));
                          }
                        })
                        .catch(console.error)
                        .finally(() => {
                          setPage(2);
                        });
                    } else {
                      setPage(3);
                    }
                  }}
                  onCancel={() => {
                    setPage(0);
                    onClose();
                  }}
                />
              </Elements>
            </ScrollView>
          </View>
        ) :
          page == 2 ? renderSuccess() :
            page == 3 ? renderFail() :
              <View style={styles.modalContainer}>
                <Text style={styles.titleNew}>Landlord Verification</Text>
                <Text style={styles.descNew}>
                  At Hubita, we verify landlords to ensure tenants can trust they are being onboarded to a legitimate property and a genuine landlord. While you can explore and use all of Hubita’s features without verification, landlord verification is required to activate tenant progression. This helps create a safer, more transparent experience for everyone on the platform.
                </Text>
                <View style={{ marginTop: 20 }}>
                  <View style={styles.row}>
                    <Text style={styles.bullet}>•</Text>
                    <Text style={styles.point}>ID Verification</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.bullet}>•</Text>
                    <Text style={styles.point}>Know Your Customer (KYC)</Text>
                  </View>
                </View>
                <Text style={styles.cost}>Total cost: £{selectedPack ? (selectedPack.price + selectedPack.vat).toFixed(2) : '...'}</Text>
                <View style={styles.footerRow}>
                  <Text style={styles.footerText}>
                    Are you happy to proceed with this purchase?
                  </Text>
                  <View style={styles.buttons}>
                    <TouchableOpacity style={styles.cancelBtn} onPress={onClose}>
                      <Text style={styles.cancelText}>Cancel</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.buyBtn} onPress={buyPackage}>
                      <Text style={styles.buyText}>Yes</Text>
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
        }
      </>
    </Modal>
  );
};

export default VerifyModal;

const styles = StyleSheet.create({
  titleNew: {
    fontSize: 26,
    fontWeight: '700',
    color: '#000',
    textAlign: 'center',
    marginBottom: 20,
  },

  descNew: {
    fontSize: 15,
    color: '#333',
    lineHeight: 22,
  },

  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },

  bullet: {
    fontSize: 18,
    marginRight: 10,
  },

  point: {
    fontSize: 16,
  },

  cost: {
    marginTop: 20,
    fontSize: 20,
    fontWeight: '700',
  },

  footerRow: {
    marginTop: 25,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  footerText: {
    flex: 1,
    fontSize: 16,
    fontWeight: '600',
    marginRight: 10,
  },

  buttons: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },

  cancelBtn: {
    backgroundColor: '#E5E5E5',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 25,
  },

  cancelText: {
    fontWeight: '600',
  },

  buyBtn: {
    backgroundColor: '#6C2BD9',
    paddingVertical: 10,
    paddingHorizontal: 26,
    borderRadius: 25,
  },

  buyText: {
    color: '#fff',
    fontWeight: '600',
  },
  modalContainer: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 20,
    width: '100%',
    maxWidth: 600,
    alignSelf: 'center',
    maxHeight: "85vh",
    overflowY: "auto",
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
  },
  checkoutModalCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 20,
    width: '100%',
    maxWidth: 500,
    maxHeight: '92vh',
    alignSelf: 'center',
    overflow: 'hidden',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05)',
  },
  checkoutHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 22,
    paddingTop: 20,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#F1F5F9',
  },
  checkoutTitleText: {
    fontSize: 20,
    fontWeight: '700',
    color: '#0F172A',
  },
  checkoutSubtitleText: {
    fontSize: 12,
    color: '#64748B',
    marginTop: 2,
  },
  secureBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    backgroundColor: '#ECFDF5',
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 12,
  },
  secureBadgeText: {
    fontSize: 11,
    fontWeight: '600',
    color: '#059669',
  },
  closeBtnCircle: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#F8FAFC',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    cursor: 'pointer',
  },
  checkoutScrollArea: {
    maxHeight: 'calc(92vh - 75px)',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
  },
  checkoutScrollContent: {
    padding: 22,
    paddingBottom: 36,
  },
  summaryCard: {
    backgroundColor: '#F8FAFC',
    borderRadius: 14,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    padding: 16,
    marginBottom: 20,
  },
  summaryTopRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  summaryItemTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#1E293B',
  },
  summaryItemSub: {
    fontSize: 12,
    color: '#64748B',
    marginTop: 2,
  },
  summaryTag: {
    backgroundColor: '#F5F3FF',
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 8,
  },
  summaryTagText: {
    fontSize: 11,
    fontWeight: '600',
    color: '#6C2BD9',
  },
  summaryDivider: {
    height: 1,
    backgroundColor: '#E2E8F0',
    marginVertical: 12,
  },
  summaryDetailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 6,
  },
  summaryDetailLabel: {
    fontSize: 13,
    color: '#64748B',
  },
  summaryDetailValue: {
    fontSize: 13,
    fontWeight: '600',
    color: '#334155',
  },
  summaryTotalRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  summaryTotalLabel: {
    fontSize: 15,
    fontWeight: '700',
    color: '#0F172A',
  },
  summaryTotalValue: {
    fontSize: 20,
    fontWeight: '800',
    color: '#6C2BD9',
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: 12,
  },
  noteBox: {
    backgroundColor: 'rgba(23, 215, 106, 0.12)',
    padding: 10,
    borderRadius: 8,
    marginBottom: 16,
  },
  noteText: {
    fontSize: 13,
    color: 'rgba(76, 78, 100, 0.87)',
    marginBottom: 8
  },
  table: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 10,
    marginBottom: 16,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f0f0f0',
    padding: 10,
    justifyContent: 'space-between',
  },
  tableHeaderText: {
    flex: 1,
    fontWeight: '600',
    fontSize: 13,
  },
  featureRow: {
    borderTopWidth: 1,
    borderTopColor: '#e0e0e0',
    padding: 10,
    flexDirection: "row"
  },
  featureItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  featureText: {
    fontSize: 13,
    flexShrink: 1,
  },
  cardScroll: {
    marginBottom: 16,
    justifyContent: "space-between",
    overflow: "scroll",
    flexDirection: "row",
  },
  card: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 12,
    padding: 16,
    marginRight: 12,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 4,
    elevation: 3,
    width: 160,
    height: 150
  },
  cardTitle: {
    fontWeight: '600',
    marginBottom: 10,
    textAlign: 'center',
  },
  cardPrice: {
    fontSize: 14,
    color: '#6b21a8',
    fontWeight: '500',
  },
  cardSub: {
    color: '#777',
    fontSize: 12,
  },
  selectBtn: {
    borderColor: '#6b21a8',
    borderWidth: 2,
    paddingVertical: 8,
    paddingHorizontal: 20,
    borderRadius: 8,
    position: "absolute",
    bottom: 10
  },
  selectBtnText: {
    fontWeight: '600',
  },
  bulkNote: {
    fontSize: 12,
    textAlign: 'center',
    color: '#066e6e',
    marginBottom: 12,
  },
  email: {
    textDecorationLine: 'underline',
    color: '#0055ff',
  },
  actions: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  cancelBtn: {
    backgroundColor: '#e0e0e0',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
    marginRight: 10
  },
  cancelText: {
    fontWeight: '600',
  },
  buyBtn: {
    backgroundColor: '#6b21a8',
    paddingVertical: 10,
    paddingHorizontal: 28,
    borderRadius: 8,
  },
  buyText: {
    color: 'white',
    fontWeight: '600',
  },
});
